module.exports = __webpack_public_path__ + "img/1280.b71299d4.svg";